/* eslint-disable no-else-return, prefer-destructuring */

import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import CheckCircle from '@material-ui/icons/CheckCircle'
import Close from '@material-ui/icons/Close'
// biome-ignore lint/suspicious/noShadowRestrictedNames: TODO
import Error from '@material-ui/icons/Error'
import Info from '@material-ui/icons/Info'
import ReportProblem from '@material-ui/icons/ReportProblem'
import cn from 'classnames'

const styles = theme => {
  const isDark = typeof document !== 'undefined' && document.documentElement.classList.contains('dark')

  return {
    alert: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      zIndex: 2,
      padding: '16px',
      borderRadius: '4px',
      border: '1px solid',
      '&.error-message': {
        backgroundColor: !isDark ? theme.status.errorBG : theme.status.errorBGDarkMode,
        borderColor: theme.status.errorBorder,
        '& $text, & $text a': {
          color: !isDark ? theme.status.errorColor : theme.status.errorColorDarkMode,
        },
        '& $icon': {
          color: !isDark ? theme.status.errorIcon : theme.status.errorIconDarkMode,
        },
      },
      '&.info-message': {
        backgroundColor: !isDark ? theme.status.infoBG : theme.status.infoBGDarkMode,
        borderColor: theme.status.infoBorder,
        '& $text, & $text a': {
          color: !isDark ? theme.status.infoColor : theme.status.infoColorDarkMode,
        },
        '& $icon': {
          color: !isDark ? theme.status.infoIcon : theme.status.infoIconDarkMode,
        },
      },
      '&.success-message': {
        backgroundColor: !isDark ? theme.status.successBG : theme.status.successBGDarkMode,
        borderColor: theme.status.successBorder,
        '& $text, & $text a': {
          color: !isDark ? theme.status.successColor : theme.status.successColorDarkMode,
        },
        '& $icon': {
          color: !isDark ? theme.status.successIcon : theme.status.successIconDarkMode,
        },
      },
      '&.warning-message': {
        backgroundColor: !isDark ? theme.status.warningBG : theme.status.warningBGDarkMode,
        borderColor: theme.status.warningBorder,
        '& $text, & $text a': {
          color: theme.status.warningColorAlert,
        },
        '& $icon': {
          color: theme.status.warningIconAlert,
        },
      },
      '&.fullWidth': {
        width: '100%',
      },
      '&.marginTop': {
        marginTop: '2em',
      },
      '&.marginBottom': {
        marginBottom: '2em',
      },
      [theme.breakpoints.down(400)]: {
        padding: '8px',
      },
    },
    icon: {
      marginRight: '20px',
      [theme.breakpoints.down(400)]: {
        marginRight: '10px',
      },
    },
    title: {
      margin: '0',
      fontSize: theme.typography.fontSizeMedish,
      [theme.breakpoints.down(400)]: {
        fontSize: theme.typography.fontSizeSm,
      },
    },
    text: {
      fontSize: theme.typography.fontSizeSm,
      fontWeight: theme.typography.fontWeightNormal,
      '& p': {
        margin: '0 0 6px 0',
      },
      '& a': {
        fontWeight: 500,
      },
      [theme.breakpoints.down(400)]: {
        fontSize: theme.typography.fontSizeSmaller,
      },
    },
    deleteButton: {
      marginLeft: 'auto',
    },
  }
}

function AlertIcon(icon, variant) {
  if (!icon) {
    if (variant === 'error') {
      return <Error />
    } else if (variant === 'info') {
      return <Info />
    } else if (variant === 'success') {
      return <CheckCircle />
    } else if (variant === 'warning') {
      return <ReportProblem />
    }
  }
  return icon
}

const AlertMessage = ({
  children,
  classes,
  className,
  fullWidth,
  icon,
  show,
  title,
  variant,
  style,
  marginTop,
  marginBottom,
  showDelete,
  onClickDelete,
}) => {
  return show ? (
    <div
      className={cn(
        classes.alert,
        className,
        `${variant}-message`,
        fullWidth && 'fullWidth',
        marginTop && 'marginTop',
        marginBottom && 'marginBottom'
      )}
      style={style}
    >
      <div className={classes.icon}>{AlertIcon(icon, variant)}</div>
      <div className={classes.text}>
        {title && <h5 className={classes.title}>{title}</h5>}
        {children}
      </div>
      {showDelete && onClickDelete && (
        <div className={classes.deleteButton}>
          <IconButton size="small" onClick={onClickDelete}>
            <Close fontSize="inherit" color="secondary" disableRipple />
          </IconButton>
        </div>
      )}
    </div>
  ) : null
}

AlertMessage.defaultProps = {
  variant: 'info',
}

const AlertMessageComponent = withStyles(styles)(AlertMessage)
AlertMessageComponent.displayName = 'AlertMessage'
export default AlertMessageComponent
